import { c as _c } from "react/compiler-runtime";
import { ContactFiledInterface, ContactSlugEnum, CountryEnum, FormInput, FormInputPhone, FormSelect, Tooltip, getContactFieldTitle, getContactSlugName, useLocalizedCountries, useTranslation as useUiTranslation } from '@systemeio/ui';
import { deleteField } from 'modules/contacts/contact-page/api/contact-edit-api';
import { ContactFieldApiInterface } from 'modules/contacts/types/contact-filter-interface';
import { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { KeyedMutator } from 'swr';
import { BinIcon } from '@systemeio/ui/icons';
interface ContactEditFieldProps {
  field: ContactFiledInterface;
  value: string | undefined;
  onChange: (value?: string) => void;
  className?: string;
  mutateFields?: KeyedMutator<ContactFieldApiInterface>;
  type: 'create' | 'edit';
  error?: string;
}
const ContactFields = t0 => {
  const $ = _c(48);
  const {
    field,
    onChange,
    className,
    value,
    mutateFields,
    type,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    countryData
  } = useLocalizedCountries();
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[0] !== field || $[1] !== tUi) {
    t1 = getContactFieldTitle(field, tUi);
    $[0] = field;
    $[1] = tUi;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const contactFieldTitle = t1;
  let t2;
  if ($[3] !== mutateFields) {
    t2 = async id => {
      if (typeof mutateFields === "undefined") {
        return;
      }
      await deleteField(id);
      await mutateFields(data => {
        if (data) {
          return {
            ...data,
            items: [...data.items.filter(el => el.id !== id)]
          };
        }
      }, false);
    };
    $[3] = mutateFields;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onDeleteField = t2;
  switch (field.slug) {
    case ContactSlugEnum.Country:
      {
        let t3;
        if ($[5] !== tUi) {
          t3 = getContactSlugName(ContactSlugEnum.Country, tUi);
          $[5] = tUi;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        let t4;
        if ($[7] !== tUi) {
          t4 = getContactSlugName(ContactSlugEnum.Country, tUi);
          $[7] = tUi;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        const t5 = value as CountryEnum;
        let t6;
        if ($[9] !== className || $[10] !== countryData || $[11] !== error || $[12] !== onChange || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
          t6 = <FormSelect containerClassName={className} label={t3} placeholder={t4} data={countryData} value={t5} onChange={onChange} error={error} />;
          $[9] = className;
          $[10] = countryData;
          $[11] = error;
          $[12] = onChange;
          $[13] = t3;
          $[14] = t4;
          $[15] = t5;
          $[16] = t6;
        } else {
          t6 = $[16];
        }
        return t6;
      }
    case ContactSlugEnum.PhoneNumber:
      {
        let t3;
        if ($[17] !== tUi) {
          t3 = getContactSlugName(ContactSlugEnum.PhoneNumber, tUi);
          $[17] = tUi;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== tUi) {
          t4 = getContactSlugName(ContactSlugEnum.PhoneNumber, tUi);
          $[19] = tUi;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        let t5;
        if ($[21] !== className || $[22] !== error || $[23] !== onChange || $[24] !== t3 || $[25] !== t4 || $[26] !== value) {
          t5 = <FormInputPhone wrapperClassName={className} label={t3} placeholder={t4} value={value} onChange={onChange} error={error} />;
          $[21] = className;
          $[22] = error;
          $[23] = onChange;
          $[24] = t3;
          $[25] = t4;
          $[26] = value;
          $[27] = t5;
        } else {
          t5 = $[27];
        }
        return t5;
      }
    default:
      {
        const t3 = field.slug === ContactSlugEnum.Email && type === "create";
        const t4 = field.slug === ContactSlugEnum.Email && type === "edit";
        let t5;
        if ($[28] !== onChange) {
          t5 = e => onChange(e.target.value);
          $[28] = onChange;
          $[29] = t5;
        } else {
          t5 = $[29];
        }
        const t6 = field.slug !== ContactSlugEnum.Email ? "w-full" : "";
        let t7;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = {
            htmlFor: "none"
          };
          $[30] = t7;
        } else {
          t7 = $[30];
        }
        let t8;
        if ($[31] !== contactFieldTitle || $[32] !== field.id || $[33] !== field.slug || $[34] !== onDeleteField || $[35] !== opened || $[36] !== t) {
          t8 = Object.values(ContactSlugEnum).includes(field.slug as ContactSlugEnum) ? contactFieldTitle : <div className="flex w-full justify-between">{contactFieldTitle}<Tooltip mode="hover" label={t("dashboard.contact_page.delete_contact_field")}><button onClick={() => setOpened(true)} className="group outline-hidden"><BinIcon className="main-transition-colors group-hover:fill-danger group-focus-visible:fill-danger h-[20px] w-[20px]" /></button></Tooltip><ConfirmationModal confirmationText={t("dashboard.contact_page.delete_contact_field_description")} toastCaption={t("dashboard.contact_page.field_removed")} opened={opened} onClose={() => setOpened(false)} onConfirm={() => onDeleteField(field.id)} /></div>;
          $[31] = contactFieldTitle;
          $[32] = field.id;
          $[33] = field.slug;
          $[34] = onDeleteField;
          $[35] = opened;
          $[36] = t;
          $[37] = t8;
        } else {
          t8 = $[37];
        }
        let t9;
        if ($[38] !== className || $[39] !== contactFieldTitle || $[40] !== error || $[41] !== t3 || $[42] !== t4 || $[43] !== t5 || $[44] !== t6 || $[45] !== t8 || $[46] !== value) {
          t9 = <FormInput required={t3} disabled={t4} className={className} value={value} error={error} onChange={t5} labelClassName={t6} nativeLabelProps={t7} label={t8} placeholder={contactFieldTitle} />;
          $[38] = className;
          $[39] = contactFieldTitle;
          $[40] = error;
          $[41] = t3;
          $[42] = t4;
          $[43] = t5;
          $[44] = t6;
          $[45] = t8;
          $[46] = value;
          $[47] = t9;
        } else {
          t9 = $[47];
        }
        return t9;
      }
  }
};
export default ContactFields;